module.exports = __webpack_public_path__ + "static/media/5.f5814a8c.png";